let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lwo4R")).then(() => parcelRequire('frHkf'));